/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{mapEasingToNativeEasing as e}from"./easing.js";function r(r,a,t,{delay:i=0,duration:n,repeat:o=0,repeatType:s="loop",ease:l,times:y}={}){const p={[a]:t};y&&(p.offset=y);const d=e(l);return Array.isArray(d)&&(p.easing=d),r.animate(p,{delay:i,duration:n,easing:Array.isArray(d)?"linear":d,fill:"both",iterations:o+1,direction:"reverse"===s?"alternate":"normal"})}export{r as animateStyle};
//# sourceMappingURL=index.js.map
